(function () {
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return "";
  }

  function closeBar() {
    const dias_expire = 7;
    setCookie("reskyt-install-app", "1", dias_expire);
    const banner = document.getElementById("app-banner");
    if (banner) banner.style.display = "none";
  }

  window.addEventListener("load", function () {
    const banner = document.getElementById("app-banner");
    if (!banner) return;

    if (window.location.href.indexOf("customapp=") !== -1) {
      setCookie("is_app_install_bar", "1", 365);
    }

    if (getCookie("is_app_install_bar") || getCookie("reskyt-install-app")) {
      banner.style.display = "none";
      return;
    }

    const ua = navigator.userAgent || "";
    const isAndroid = /Android/i.test(ua);
    const isIOS = /iPhone|iPad|iPod/i.test(ua);

    const btnAndroid = document.getElementById("btn-android");
    const btnIOS = document.getElementById("btn-ios");
    const btnOther = document.getElementById("btn-other");

    if (isAndroid && btnAndroid) btnAndroid.style.display = "inline-block";
    else if (isIOS && btnIOS) btnIOS.style.display = "inline-block";
    else if (btnOther) btnOther.style.display = "inline-block";

    banner.style.display = "block";

    const closeBtn = document.getElementById("close-app-banner");
    if (closeBtn) closeBtn.addEventListener("click", closeBar);
  });
})();